// Rename the dossier or correct its entity. A new entity re-checks every
// document's "another company" flag on the server, so readiness and drafting
// sources change at once.
import { useState } from "react";
import { Pencil } from "lucide-react";
import { api } from "../api/client";
import { invalidate, useMutation } from "../api/resource";
import { useCurrentUser } from "../auth";
import { keys, useDossier } from "../dossier";
import { w } from "../i18n";
import { Dialog } from "./overlay";
import { ErrorState, Notice } from "./ui";

export function EditDossierButton() {
  const { dossier } = useDossier();
  const { can } = useCurrentUser();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(dossier.name);
  const [entity, setEntity] = useState(dossier.entity_name);
  const [year, setYear] = useState(String(dossier.reporting_year));
  const save = useMutation(api.updateDossier);
  const entityChanged = entity.trim() !== dossier.entity_name;
  const yearValid = /^\d{4}$/.test(year) && Number(year) >= 2000 && Number(year) <= 2100;
  const yearChanged = yearValid && Number(year) !== dossier.reporting_year;
  const submit = async () => {
    if (await save.run(dossier.id, { name: name.trim(), entity_name: entity.trim(), reporting_year: Number(year) })) {
      invalidate(`dossier:${dossier.id}`, "dossiers", keys.documents(dossier.id), keys.readiness(dossier.id),
        keys.audit(dossier.id), "document:", `inputs:${dossier.id}`, `datapoints:${dossier.id}`);
      setOpen(false);
    }
  };
  const start = () => { setName(dossier.name); setEntity(dossier.entity_name); setYear(String(dossier.reporting_year)); setOpen(true); };
  return <>
    <button className="ws-btn" onClick={start} disabled={!can("approver")}
      title={can("approver") ? undefined : w("auth.needs", { role: w("role.user.approver") })}>
      <Pencil size={16} />{w("dossierEdit.button")}</button>
    {open && <Dialog title={w("dossierEdit.title")} onClose={() => setOpen(false)} size="sm"
      footer={<><button className="ws-btn" onClick={() => setOpen(false)}>{w("common.cancel")}</button>
        <button className="ws-btn primary" disabled={save.pending || !name.trim() || !entity.trim() || !yearValid} onClick={submit}>
          {w("dossierEdit.save")}</button></>}>
      <div className="ws-field"><label htmlFor="de-name">{w("dossierEdit.name")}</label>
        <input id="de-name" className="ws-input" value={name} onChange={e => setName(e.target.value)} maxLength={200} /></div>
      <div className="ws-field"><label htmlFor="de-entity">{w("dossierEdit.entity")}</label>
        <input id="de-entity" className="ws-input" value={entity} onChange={e => setEntity(e.target.value)} maxLength={200} /></div>
      <div className="ws-field"><label htmlFor="de-year">{w("dossierEdit.year")}</label>
        <input id="de-year" className="ws-input" inputMode="numeric" value={year} onChange={e => setYear(e.target.value)} /></div>
      {entityChanged && <Notice tone="info">{w("dossierEdit.entityNote")}</Notice>}
      {yearChanged && <div style={{ marginTop: 8 }}><Notice tone="info">{w("dossierEdit.yearNote", { year })}</Notice></div>}
      {save.error && <ErrorState title={w("dossierEdit.error")} error={save.error} />}
    </Dialog>}
  </>;
}
